import { useCookies } from 'react-cookie';

const TOUR_CALENDAR_SURVEY_COOKIE = 'hasClosedTourCalendarSurveyAlert';

export default function useTourCalendarSurveyCookie() {
  const [cookies, setCookies] = useCookies([TOUR_CALENDAR_SURVEY_COOKIE]);
  const hasDismissedTourCalendarSurvey = cookies[TOUR_CALENDAR_SURVEY_COOKIE]?.toLowerCase() === 'true' || false;

  const setTourCalendarSurveyCookie = () => {
    if (!hasDismissedTourCalendarSurvey) {
      setCookies(TOUR_CALENDAR_SURVEY_COOKIE, true, { path: '/' });
    }
  };

  return { hasDismissedTourCalendarSurvey, setTourCalendarSurveyCookie };
}
